import React from 'react';
import cls from 'classnames';

import {
  CounterBadge as CounterBadgeTPA,
  CounterBadgePriority,
} from '@wix/wix-ui-tpa/cssVars';

import classes from './CounterBadge.scss';

interface IProps
  extends Omit<React.ComponentProps<typeof CounterBadgeTPA>, 'priority'> {
  color: 'danger';
  secondary?: boolean;
}

export function CounterBadge(props: IProps) {
  const { className, color, secondary, ...rest } = props;

  return (
    <CounterBadgeTPA
      className={cls(classes.root, className, classes[color])}
      priority={
        secondary
          ? CounterBadgePriority.secondary
          : CounterBadgePriority.primary
      }
      {...rest}
    />
  );
}

CounterBadge.displayName = 'wui/CounterBadge';
